module.exports = __webpack_public_path__ + "img/W-AS3485009.357cb430.jpg";